// extracted by mini-css-extract-plugin
export default {"row":"src-views-common-components-SDSPanel-SDSPanelRow-SDSPanelRow__row--pToua"};